import { useTaskGridPreferencesQuery, useUpdateTaskGridPreferencesMutation } from "./queries";
import type { AutoAddSide } from "../types";

export default function useAutoAddPrefs() {
  const prefsQuery = useTaskGridPreferencesQuery();
  const updatePrefs = useUpdateTaskGridPreferencesMutation();

  const autoAdd: boolean = prefsQuery.data?.autoAdd ?? true;
  const side: AutoAddSide = prefsQuery.data?.autoAddSide ?? "left";

  const setAutoAdd = (next: boolean) => {
    if (next === autoAdd) return;
    updatePrefs.mutate({ autoAdd: next });
  };

  const setSide = (next: AutoAddSide) => {
    if (next === side) return;
    updatePrefs.mutate({ autoAddSide: next });
  };

  return { autoAdd, setAutoAdd, side, setSide };
}
